export default __webpack_public_path__ + "static/media/LeekHotPot_06.75d07555.png";